module.exports = __webpack_public_path__ + "img/green-2-squiggly-solid.c9de3125.svg";